import React from "react";
import { Row, Col } from "react-bootstrap";
import { FiSearch } from "react-icons/fi";
import { LuFilterX } from "react-icons/lu";
import CustomButton from "./CustomButton";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Header } from "../pages/Home";
import CustomSelectBox from "./Inputs/CustomSelectBox";

function HeaderAndFilters({
  filters,
  showHeader,
  headerIcon,
  headerTitle,
  projectOptions,
  workstreamOptions,
  createdByOptions,
  handleClick,
  onFilterChange,
  newButtonText,
  searchPlaceholder,
  showProjectButton,
  showWorkstreamButton,
  showCreatedByButton,
}) {
  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    onFilterChange({ ...filters, search: searchValue });
  };

  const handleProjectChange = (e) => {
    onFilterChange({ ...filters, project: e.target.value });
  };

  const handleWorkstreamChange = (e) => {
    onFilterChange({ ...filters, workstream: e.target.value });
  };

  const handleCreatedByChange = (e) => {
    onFilterChange({ ...filters, user: e.target.value });
  };

  const handleResetClick = () => {
    const resetFilters = {
    search: "",       
    project: "",       
    workstream: "",    
    user: "",          
    };
  onFilterChange(resetFilters); 
  };

  return (
    <div >
      {showHeader && (
        <Header 
          title={headerTitle}
          onButtonClick={() => handleClick(newButtonText)}
          buttonTitle={newButtonText}
          icon={headerIcon}
        />
      )}
      <div className="py-4 bg-white border-bottom-0" style={{ border: "1px solid #f0efef" }}>
        <Row className="pb-4 pt-4 px-3">
          <Col xs={12} sm={5} className="mb-3 mb-sm-0">
            <div className="d-flex align-items-center rounded-pill border p-2">
              <input
                type="text"
                placeholder={searchPlaceholder}
                className="flex-grow-1 border-0 no-focus-outline p-0 ms-2"
                onChange={handleSearchChange}
              />
              <FiSearch className="text-muted me-2" size={20} />
            </div>
          </Col>
          <Col xs={12} sm={7} className="d-flex justify-content-end align-items-center gap-3">
            {showProjectButton && (
              <CustomSelectBox
                name="project"
                options={projectOptions}
                value={filters.project || ""}
                onChange={handleProjectChange}
                placeholder="Select a Project"
                fullWidth={false}
               
              />
            )}
            {showWorkstreamButton && (
              <CustomSelectBox
                name="workstream"
                options={workstreamOptions}
                value={filters.workstream || ""}
                onChange={handleWorkstreamChange}
                placeholder="Select a Workstream"
                fullWidth={false}
              />
            )}
            {showCreatedByButton && (
              <CustomSelectBox
                name="createdBy"
                options={createdByOptions}
                value={filters.user || ""}
                onChange={handleCreatedByChange}
                placeholder="Select a User"
                fullWidth={false}
              />
            )}
            <button
              onClick={handleResetClick}
              className="rounded-pill p-2 border mb-3 "
            >
              <LuFilterX size={25} color={"gray"}/>
            </button>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default HeaderAndFilters;
